'use client';
import { useState } from 'react';
import { APP_DOMAIN } from '@/constants';
import { RenderProviders } from '@/components/presentational/tailwind/Auth/RenderProviders';
import { useSignInWithProvider, useSignUp } from '@/utils/react-query-hooks';
import Anchor from 'shared-ui/components/Anchor';
import Input from 'src/components/forms/Input';
import { LoadingSpinner } from '@/components/presentational/tailwind/LoadingSpinner';
import InvalidLoginError from '../components/InvalidLoginError';

export function SignUp() {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const [isSuccessful, setIsSuccessful] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  function redirectToDashboard() {
    setIsSuccessful(true);
    window.location.href = `${process.env.NODE_ENV == 'production' ? 'https://' : 'http://'}${APP_DOMAIN}`;
  }
  // const [successMessage, setSuccessMessage] = useState<string | null>(null);
  // const magicLinkMutation = useSignInWithMagicLink({
  //   onSuccess: () => {
  //     setSuccessMessage('A magic link has been sent to your email!');
  //   },
  //   onMutate: () => {
  //     setSuccessMessage(null);
  //   },
  // });

  const passwordMutation = useSignUp({
    onError: (error: any) => {
      if (error.message === 'User already registered')
        setErrorMessage(`An OkGrow account with this email already exists. You can <a href='/login' class='font-medium underline'>log in instead</a>.`)
      else
        setErrorMessage(error.message);
    },
    onSuccess: redirectToDashboard,
  });
  const providerMutation = useSignInWithProvider();

  return (
    <>
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-medium">Start your 1-day free trial now</h1>
        <p className="mx-auto text-sm max-w-72 text-neutral-500">
          Create your free account on OkGrow to start growing your TikTok today.
        </p>
      </div>

      {isSuccessful ? (
        <div className='items-center mx-auto my-12 text-center'>
          <LoadingSpinner className="w-8 h-8 !mx-auto text-turquoise" />
          <p className="mt-3 text-sm font-medium text-turquoise">Creating your account...</p>
        </div>
      ) : (
          <>
            <form className="mt-8 mb-6 space-y-4" onSubmit={(e) => {
              e.preventDefault();
              passwordMutation.mutate({
                email: e.currentTarget.email.value,
                password: e.currentTarget.password.value,
              });
            }}
            >

              {errorMessage && (
                <InvalidLoginError errorMessage={errorMessage} />
              )}

              <Input id="email" label="Email Address" placeholder="Enter email address" name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={passwordMutation.isLoading}
                autoComplete={'email'}
                required
                autoFocus
              />
              <Input id="password" label="Password" placeholder="Enter password" type="password" name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={passwordMutation.isLoading}
                autoComplete={'new-password'}
                required
              />

              <button className="relative w-full p-px rounded-full h-9 bg-btn-gradient shadow-btn-outline-stroke" type="submit">
                <span className="inline-flex items-center justify-center font-medium text-white rounded-full bg-turquoise-medium size-full text-sm/8">
                  {passwordMutation.isLoading ? (
                    <div className='inline-flex items-center justify-center transition-all animate-fade-in'>
                      <LoadingSpinner className="relative w-4 h-4 mr-2 text-white" />
                      Signing up...
                    </div>
                  ) :
                    <div className='inline-flex items-center justify-center animate-fade-in-up-short'>
                      Start your free trial
                    </div>
                  }
                </span>
              </button>

              <div className="space-y-6">
                <div className="relative leading-none text-center">
                  <span className="relative z-10 inline-block px-3 font-medium bg-white text-neutral-400 text-xs/4">or</span>
                  <div className="absolute left-0 w-full h-px -translate-y-1/2 bg-neutral-200 top-1/2"></div>
                </div>

              </div>
            </form>
            <RenderProviders
              providers={['google']}
              isLogin={false}
              isLoading={providerMutation.isLoading}
              onProviderLoginRequested={(provider) => {
                providerMutation.mutate({
                  provider,
                });
              }}
            />

            <p className="mt-6 text-sm text-center text-neutral-500">
              Already have an account?{" "}
              <Anchor href="/login" className="underline underline-offset-4">
                Login
              </Anchor>
            </p>
          </>
      )}
    </>
  );
}
